function ClientTermsPage() {
  return (
    <main
      className="min-h-screen px-6 py-8 md:px-10 md:py-10"
      style={{
        background:
          "radial-gradient(circle at 8% 0%, #dcfce7 0, transparent 30%), radial-gradient(circle at 100% 10%, #dbeafe 0, transparent 34%), linear-gradient(160deg, #f8fafc 0%, #eef2ff 100%)",
      }}
    >
      <div className="mx-auto w-full max-w-[980px]">
        <section className="rounded-3xl border border-[#dbe4f4] bg-white/90 p-6 shadow-[0_12px_30px_rgba(15,23,42,0.06)]">
          <p className="m-0 inline-block rounded-full bg-[#111827] px-3 py-1 text-xs font-bold tracking-[0.08em] text-white">
            TERMS OF SERVICE
          </p>
          <h1 className="mt-3 text-[clamp(24px,4.5vw,34px)] font-semibold leading-tight tracking-[-0.03em] text-[#0f172a]">
            이용약관
          </h1>
          <p className="mt-2 text-xs text-[#667085]">
            시행일: 2026-03-09 | 버전: v1.0
          </p>
        </section>

        <section className="mt-6 space-y-4 rounded-3xl border border-[#dbe4f4] bg-white/90 p-6 text-sm leading-7 text-[#344054] shadow-[0_12px_30px_rgba(15,23,42,0.06)]">
          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              제1조 (목적)
            </h2>
            <p className="mt-2">
              본 약관은 Ah Shoot 서비스 운영자(이하 &quot;운영자&quot;)가
              제공하는 축구팀 운영 플랫폼 서비스(이하 &quot;서비스&quot;)의
              이용과 관련하여 운영자와 이용자의 권리, 의무 및 책임사항을
              규정함을 목적으로 합니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              제2조 (정의)
            </h2>
            <p className="mt-2">
              이용자란 본 약관에 따라 서비스를 이용하는 회원을 의미합니다.
              회원은 이메일 로그인 또는 소셜로그인 등 운영자가 제공하는 인증
              방식을 통해 인증을 완료한 자를 말합니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              제3조 (약관의 효력 및 변경)
            </h2>
            <p className="mt-2">
              운영자는 관련 법령을 위반하지 않는 범위에서 약관을 변경할 수
              있으며, 변경 시 시행일과 변경 사유를 서비스 화면에 공지합니다.
              이용자가 변경 약관 시행 이후 서비스를 계속 이용하는 경우 동의한
              것으로 봅니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              제4조 (서비스 제공 및 변경)
            </h2>
            <p className="mt-2">운영자는 다음 기능을 제공합니다.</p>
            <p className="mt-1">
              팀 생성/가입/회원관리, 일정 등록/조회/투표, 투표 독촉 알림, 라인업
              관리, 알림 기능, 출석 체크를 위한 위치 기반 기능
            </p>
            <p className="mt-2">
              운영자는 운영상 또는 기술상 필요에 따라 서비스의 전부 또는 일부를
              변경/중단할 수 있습니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              제4조의2 (동의 및 선택 항목)
            </h2>
            <p className="mt-2">
              회원가입 및 로그인 과정에서 이용약관 및 개인정보 처리방침 동의는
              필수이며, 마케팅 정보 수신 동의는 선택입니다. 선택 동의 항목은
              서비스 내 설정 화면에서 변경할 수 있습니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              제5조 (회원의 의무)
            </h2>
            <p className="mt-2">이용자는 다음 행위를 해서는 안 됩니다.</p>
            <p className="mt-1">
              타인의 정보 도용, 서비스 운영 방해, 불법 정보 게시, 타 회원에 대한
              명예훼손/모욕, 악성 스크립트/자동화 도구를 통한 비정상 접근
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              제6조 (회원 탈퇴 및 이용제한)
            </h2>
            <p className="mt-2">
              이용자는 언제든지 회원탈퇴를 요청할 수 있습니다. 운영자는 약관
              위반 또는 법령 위반 행위가 확인되는 경우 서비스 이용을 제한할 수
              있습니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              제7조 (지식재산권)
            </h2>
            <p className="mt-2">
              서비스 및 서비스 내 제공되는 콘텐츠에 대한 저작권 및 지식재산권은
              운영자 또는 정당한 권리자에게 귀속됩니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              제8조 (면책)
            </h2>
            <p className="mt-2">
              운영자는 천재지변, 불가항력, 이용자 귀책사유로 발생한 손해에 대해
              책임을 지지 않습니다. 운영자는 무료로 제공되는 서비스에 대하여
              관련 법령에 특별한 규정이 없는 한 책임을 제한할 수 있습니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              제9조 (준거법 및 관할)
            </h2>
            <p className="mt-2">
              본 약관은 대한민국 법령을 준거법으로 하며, 서비스 이용과 관련해
              분쟁이 발생하는 경우 민사소송법상 관할 법원을 따릅니다.
            </p>
          </article>

          {/* <article className="rounded-xl border border-[#eaecf0] bg-[#f8fafc] px-4 py-3 text-xs leading-6 text-[#667085]">
            본 문서는 서비스 운영을 위한 기본 약관 템플릿이며, 실제 사업 상황에 맞춘 최종
            법률검토가 필요할 수 있습니다.
          </article> */}
        </section>
      </div>
    </main>
  );
}

export default ClientTermsPage;
